
import { useEffect, useState } from "react";
import PersonCard from '../../../components/PersonCard/PersonCard';
import styles from './nachhaltigkeit.module.css'
import { loadAssignmentsByArea } from '../../../../code/AssignmentPersons';
import { nachhaltigkeitsziele } from "../../../../config/references_files";
function Nachhaltigkeit() {
    const [ansprechpartnerPerson, setAnsprechpartnerPerson] = useState(null);
    const color = '--color-red';
    const colorText = "--main-color-white";
    useEffect(() => {
        loadAssignmentsByArea(6, setAnsprechpartnerPerson, color, colorText, true);
    }, []);
    return (
        <section className={styles.container}>
            <h1>Nachhaltigkeit beim TuS</h1>
            <section>
                <h2>Natur nutzen & schützen - "Kreisläufe" aus sportlicher Sicht</h2>
                <div className={styles.textContainer}>
                    <div className={styles.person}>
                        {ansprechpartnerPerson && <PersonCard person={ansprechpartnerPerson} />}
                    </div>
                    <div className={styles.textWrapper}>
                        <p>Beim TuS 05 Oberpleis e.V. hat das Thema Nachhaltigkeit oberste Priorität.</p>
                        <p>Wir stehen als moderner Sportverein für die sozialen, ökologischen und ökonomischen Ziele, die in der „Agenda 2030“ mit den „17 globalen Ziele für nachhaltige Entwicklung“ verankert sind.</p>
                        <p>Mit dem Ziel, unser tägliches Wirken zu überprüfen, haben wir die 17 Ziele auf den TuS übertragen.</p>
                        <a href={nachhaltigkeitsziele}
                            target="_blank" rel="noopener noreferrer"
                        >Unsere Ziele findet ihr hier beschrieben.</a>
                    </div>
                </div>
                <div className={styles.textWrapper}>
                    <p>Ein Projekt in Sachen Nachhaltigkeit beim TuS ist der „Flohmarkt“, der sowohl über eine WhatsApp-Gruppe (<span>0175 – 58 44 744</span>) als auch einmal jährlich in Präsenz, die Möglichkeit bietet, getragene Kleidung zu kaufen und zu verkaufen.</p>
                    <p>Die Idee: „Schnell sind Kinder aus Jacke und Hose rausgewachsen, der Fußball ist nicht mehr interessant oder es braucht einen neuen Badminton-Schläger: ganz praktisch und schnell kann hier gesucht und angeboten werden und es muss nichts in der Tonne landen! Die Sport-Kleidung oder Sportgeräte können umsonst, gegen Bares oder z.B. gegen Spende für die Jugendarbeit beim TuS weiterwandern.“ </p>
                    <p>Wir bleiben an dem Thema Nachhaltigkeit dran.</p>
                    <p>Wir bleiben an dem Thema Nachhaltigkeit dran. Wenn Du ähnliche Ideen für unser Vereinsleben hast oder an diesem Thema gern im TuS mitarbeiten möchtest, dann melde Dich gern – per Mail <a href="mailto:m.weber@tus05-oberpleis.de">m.weber@tus05-oberpleis.de</a> oder telefonisch unter <span>02244 – 90 20 117.</span></p>
                </div>
            </section>
        </section>
    );
}
export default Nachhaltigkeit;